import { useState } from "react";
import { Bell, Check } from "lucide-react";
import { subscribeNotify } from "../api";

/* Email capture shown on coming-soon products. Size is optional and pre-filled from the PDP. */
export const NotifyMe = ({ slug, size }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | loading | done | error
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("loading");
    try {
      const r = await subscribeNotify({ email: email.trim(), slug, size: size || "" });
      setMsg(r.status === "already_subscribed" ? "YOU'RE ALREADY ON THE LIST" : "YOU'RE ON THE LIST — WE'LL EMAIL YOU THE MOMENT IT DROPS");
      setState("done");
    } catch (err) {
      setMsg(err?.response?.data?.detail || "SOMETHING WENT WRONG — TRY AGAIN");
      setState("error");
    }
  };

  if (state === "done") {
    return (
      <div className="mt-5 flex items-start gap-3 border border-black p-4" data-testid="notify-success">
        <Check className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={2} />
        <p className="text-[11px] font-medium tracking-[0.12em] leading-relaxed">{msg}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mt-5" data-testid="notify-form">
      <p className="flex items-center gap-2 text-[11px] font-medium tracking-[0.2em] mb-3">
        <Bell className="w-3.5 h-3.5" strokeWidth={2} />
        NOTIFY ME WHEN IT DROPS{size ? ` — SIZE ${size}` : ""}
      </p>
      <div className="flex">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          aria-label="Email address"
          data-testid="notify-email-input"
          className="flex-1 min-w-0 border border-black px-3 h-12 text-[13px] outline-none focus:bg-[#f7f7f7] placeholder:text-black/40"
        />
        <button
          type="submit"
          disabled={state === "loading"}
          data-testid="notify-submit-button"
          className="h-12 px-5 bg-black text-white text-[11px] font-medium tracking-[0.2em] hover:bg-[#e50000] transition-colors disabled:opacity-60"
        >
          {state === "loading" ? "..." : "NOTIFY ME"}
        </button>
      </div>
      {state === "error" && (
        <p className="text-[11px] tracking-[0.1em] text-[#e50000] mt-2" data-testid="notify-error">
          {typeof msg === "string" ? msg : "SOMETHING WENT WRONG — TRY AGAIN"}
        </p>
      )}
    </form>
  );
};
